module.exports = __webpack_public_path__ + "img/towers.0ca19567.webp";